// extracted by mini-css-extract-plugin
export default {"users-permissions-sidebar":"UsersPermissionsSidebar_users-permissions-sidebar__XlYUw","sidebar-title":"UsersPermissionsSidebar_sidebar-title__t+a+B"};